import { jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { s as styles } from "../../../../chunks/Modal.module-Cut2QRny.js";
const ModalFooter = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsx("footer", { className: clsx(styles.modalFooter, className), ...props, children });
};
export {
  ModalFooter
};
